import {linearProgressiveBlur} from '@remotion/effects/linear-progressive-blur';
import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {HtmlInCanvasMotionBlur} from '@remotion/motion-blur';
import {
	AbsoluteFill,
	Easing,
	Freeze,
	HtmlInCanvas,
	Interactive,
	Internals,
	interpolate,
	Solid,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';

const getAudioRollingCursorTranslate = (frame: number) =>
	interpolate(
		frame,
		[
			-223, -222, -221, -220, -219, -218, -217, -216, -215, -214, -213, -212,
			-211, -210, -209, -208, -207, -206, -205, -204, -203, -202, -201, -200,
			-199, -198, -197, -196, -195, -194, -193, -192, -191, -190, -189, -188,
			-187, -186, -185, -184, -183, -182, -181, -180, -179, -178, -177, -176,
			-175, -174, -173, -172, -171, -170, -169, -168, -167, -166, -165, -164,
			-163, -162, -161, -160, -159, -158, -157, -156, -155, -154, -153, -152,
			-151, -150, -149, -148, -147, -146, -145, -143, -142, -127, -126, -125,
			-124, -123, -122, -121, -120, -119, -118, -117, -116, -115, -114, -113,
			-112, -111, -110, -109, -108, -107, -106, -105, -104, -103, -102, -101,
			-100, -99, -98, -97, -96, -95, -94, -93, -92, -91, -90, -89, -88, -87,
			-86, -85, -84, -83, -82, -81, -80, -79, -78, -77, -76, -75, -74, -73, -72,
			-71, -70, -69, -68, -67, -66, -65, -64, -63, -62, -61, -60, -59, -58, -57,
			-56, -55, -54, -53, -52, -51, -50, -49, -48, -47, -46, -45, -44, -43, -42,
			-41, -40, -39, -38, -36, -35, -16, -15, -12, -11, -9, -8, -7, -6, -5, -4,
			-3, -2, -1, 0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 15, 16, 17, 18, 19,
			20, 21, 22, 23, 24, 25, 26, 28, 29, 44, 45, 46, 47, 48, 49, 50, 51, 52,
			53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 69, 70, 71, 72, 73,
			74, 75, 76, 77, 78, 79, 81, 82, 83, 84, 85, 86, 87, 88, 90, 91, 92, 94,
			95, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110,
			111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125,
			126, 129, 130, 134, 135, 138, 139, 143, 144, 145, 192, 193, 194, 195, 196,
			197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211,
			212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226,
			227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241,
			242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256,
			257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271,
			272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286,
			287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301,
			302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 317,
			318, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 332, 333, 334,
			335, 336, 337, 338, 339, 340, 341, 342, 344, 345, 347, 348, 446, 447, 448,
			449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463,
			464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478,
			479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493,
			494, 495,
		],
		[
			'2906.50381125697px 1012.9682470808426px',
			'2858.0430150701695px 1012.9682470808426px',
			'2782.49192091237px 1029.497639416881px',
			'2710.6545518130183px 1043.8551657589162px',
			'2466.891607463199px 1089.4477725032543px',
			'2264.128850923833px 1114.780682723381px',
			'2092.203275673365px 1146.015763125684px',
			'1934.4031189487794px 1161.0032963972774px',
			'1770.3857885772386px 1179.4227095219899px',
			'1675.5200082895649px 1185.3414588338912px',
			'1619.2836002616393px 1185.3414588338912px',
			'1570.8228040748393px 1185.3414588338912px',
			'1536.6697968408985px 1185.3414588338912px',
			'1514.3377091010354px 1185.3414588338912px',
			'1505.38497904942px 1185.3414588338912px',
			'1496.4322489978044px 1185.3414588338912px',
			'1490.3311292589258px 1185.3414588338912px',
			'1487.0816198327839px 1185.3414588338912px',
			'1483.832110406642px 1183.7167041208204px',
			'1480.8644461858287px 1182.373794613078px',
			'1479.2396914727576px 1180.7490399000071px',
			'1477.8967819650154px 1179.124285186936px',
			'1476.553872457273px 1179.124285186936px',
			'1476.553872457273px 1177.880850457545px',
			'1476.553872457273px 1177.880850457545px',
			'1476.553872457273px 1176.637415728154px',
			'1476.553872457273px 1176.637415728154px',
			'1476.553872457273px 1174.0510714910206px',
			'1476.553872457273px 1170.8015620648787px',
			'1476.553872457273px 1169.1768073518078px',
			'1476.553872457273px 1166.2091431309946px',
			'1474.9291177442021px 1162.9596337048526px',
			'1474.9291177442021px 1159.7101242787107px',
			'1473.304363031131px 1158.0853695656397px',
			'1471.6796083180602px 1156.7424600578975px',
			'1471.6796083180602px 1155.399550550155px',
			'1470.0548536049891px 1155.399550550155px',
			'1470.0548536049891px 1154.222432339665px',
			'1468.711944097247px 1154.222432339665px',
			'1468.711944097247px 1154.222432339665px',
			'1467.5348258867566px 1154.222432339665px',
			'1467.5348258867566px 1152.5976776265938px',
			'1464.5671616659433px 1152.5976776265938px',
			'1463.2242521582011px 1152.5976776265938px',
			'1460.2565879373878px 1152.5976776265938px',
			'1457.007078511246px 1152.5976776265938px',
			'1453.757569085104px 1152.5976776265938px',
			'1447.6564493462254px 1152.5976776265938px',
			'1438.7037192946098px 1152.5976776265938px',
			'1429.7509892429944px 1150.35949511369px',
			'1416.7529515384267px 1150.35949511369px',
			'1403.7549138338588px 1150.35949511369px',
			'1386.7115684763392px 1150.35949511369px',
			'1369.6682231188192px 1150.35949511369px',
			'1352.6248777612993px 1147.5078848009532px',
			'1339.6268400567317px 1147.5078848009532px',
			'1318.107129673404px 1144.6562744882165px',
			'1301.0637843158843px 1141.8046641754797px',
			'1292.1110542642687px 1141.8046641754797px',
			'1279.113016559701px 1138.953053862743px',
			'1266.1149788551334px 1138.953053862743px',
			'1253.1169411505657px 1138.953053862743px',
			'1240.118903445998px 1138.953053862743px',
			'1231.597230767238px 1138.953053862743px',
			'1222.6445007156226px 1136.714871349839px',
			'1213.691770664007px 1136.714871349839px',
			'1200.6937329594393px 1136.714871349839px',
			'1187.6956952548717px 1134.4766888369352px',
			'1170.2212925244962px 1134.4766888369352px',
			'1161.2685624728808px 1134.4766888369352px',
			'1155.167442734002px 1134.4766888369352px',
			'1141.7383476565788px 1134.4766888369352px',
			'1135.6372279177px 1134.4766888369352px',
			'1132.3877184915582px 1134.4766888369352px',
			'1129.1382090654163px 1134.4766888369352px',
			'1125.8886996392744px 1136.0848644202808px',
			'1125.8886996392744px 1136.0848644202808px',
			'1124.6452649098833px 1137.6930400036267px',
			'1123.302355402141px 1137.6930400036267px',
			'1123.302355402141px 1137.6930400036267px',
			'1122.1749745808265px 1137.6930400036267px',
			'1122.1749745808265px 1137.6930400036267px',
			'1123.2028806237897px 1137.6930400036267px',
			'1129.270842103218px 1137.6930400036267px',
			'1146.2810292012873px 1137.6930400036267px',
			'1159.2459086464046px 1137.6930400036267px',
			'1165.3138701258329px 1137.6930400036267px',
			'1171.3818316052611px 1136.0682852905557px',
			'1174.5981827719527px 1134.4435305774848px',
			'1177.8145339386442px 1132.8187758644137px',
			'1185.4906710014181px 1127.331083925368px',
			'1191.5586324808464px 1121.2299641864893px',
			'1198.2400217601078px 1112.2772341348737px',
			'1207.1595935522728px 1103.3245040832583px',
			'1220.12447299739px 1093.1614975617022px',
			'1233.0893524425073px 1082.998491040146px',
			'1242.0089242346723px 1074.0457609885307px',
			'1248.6903135139335px 1067.331213449819px',
			'1257.6098853060987px 1060.6166659111072px',
			'1263.677846785527px 1054.5155461722286px',
			'1277.0572044737744px 1043.3246336077093px',
			'1287.1870527358801px 1032.5647784160456px',
			'1296.1066245280451px 1023.6120483644299px',
			'1305.0261963202104px 1014.6593183128144px',
			'1309.4859822162928px 1012.4211357999105px',
			'1316.167371495554px 1003.4684057482951px',
			'1329.5467291838015px 994.5156756966796px',
			'1336.2281184630629px 987.8011281579679px',
			'1345.1476902552279px 983.3247631321602px',
			'1351.2156517346561px 979.4618259061854px',
			'1354.4320029013477px 976.2123164800435px',
			'1360.499964380776px 972.3493792540686px',
			'1366.5679258602042px 970.7246245409976px',
			'1369.7842770268958px 967.4751151148557px',
			'1373.000628193587px 964.2256056887138px',
			'1376.2169793602786px 960.9760962625719px',
			'1383.8931164230528px 957.72658683643px',
			'1389.961077902481px 955.4884043235261px',
			'1393.1774290691724px 953.8636496104551px',
			'1399.2453905486007px 952.2388948973842px',
			'1405.313352028029px 950.6141401843132px',
			'1411.3813135074572px 948.3759576714094px',
			'1417.4492749868855px 946.1377751585055px',
			'1423.5172364663138px 944.5130204454346px',
			'1429.585197945742px 942.8882657323636px',
			'1438.5047697379073px 940.6500832194597px',
			'1444.5727312173356px 940.6500832194597px',
			'1452.2488682801095px 939.0253285063887px',
			'1458.3168297595378px 936.7871459934848px',
			'1464.384791238966px 936.7871459934848px',
			'1470.4527527183943px 934.548963480581px',
			'1479.3723245105593px 934.548963480581px',
			'1485.4402859899876px 932.3107809676771px',
			'1491.508247469416px 932.3107809676771px',
			'1500.4278192615811px 932.3107809676771px',
			'1506.4957807410094px 930.0725984547732px',
			'1512.5637422204377px 930.0725984547732px',
			'1518.631703699866px 930.0725984547732px',
			'1526.30784076264px 928.4478437417023px',
			'1532.3758022420682px 928.4478437417023px',
			'1541.2953740342332px 928.4478437417023px',
			'1547.3633355136615px 928.4478437417023px',
			'1553.4312969930897px 928.4478437417023px',
			'1556.6476481597813px 928.4478437417023px',
			'1559.8639993264728px 928.4478437417023px',
			'1563.0803504931644px 926.8230890286313px',
			'1566.2967016598557px 926.8230890286313px',
			'1572.7294039932387px 926.8230890286313px',
			'1574.3375795765844px 926.8230890286313px',
			'1577.553930743276px 925.1983343155604px',
			'1580.7702819099675px 925.1983343155604px',
			'1583.986633076659px 925.1983343155604px',
			'1586.921139038022px 923.5735796024894px',
			'1588.5293146213676px 923.5735796024894px',
			'1591.4638205827305px 923.5735796024894px',
			'1592.7901509607475px 923.5735796024894px',
			'1592.7901509607475px 923.5735796024894px',
			'1594.0170065604134px 923.5735796024894px',
			'1595.2438621600793px 923.5735796024894px',
			'1596.5701925380963px 923.5735796024894px',
			'1596.5701925380963px 923.5735796024894px',
			'1597.7307316188612px 923.5735796024894px',
			'1599.0570619968785px 923.5735796024894px',
			'1600.2839175965441px 923.5735796024894px',
			'1600.2839175965441px 923.5735796024894px',
			'1601.51077319621px 923.5735796024894px',
			'1602.737628795876px 923.5735796024894px',
			'1604.063959173893px 922.2306700947471px',
			'1605.2908147735588px 922.2306700947471px',
			'1605.2908147735588px 922.2306700947471px',
			'1606.4513538543238px 922.2306700947471px',
			'1606.4513538543238px 922.2306700947471px',
			'1607.5953138053635px 922.2306700947471px',
			'1607.5953138053635px 922.2306700947471px',
			'1608.6232198483267px 922.2306700947471px',
			'1608.6232198483267px 922.2306700947471px',
			'1609.7174424101909px 922.2306700947471px',
			'1609.7174424101909px 922.2306700947471px',
			'1610.8614023612306px 922.2306700947471px',
			'1612.0219414419958px 922.2306700947471px',
			'1612.0219414419958px 922.2306700947471px',
			'1613.2487970416614px 922.2306700947471px',
			'1616.1833030030243px 922.2306700947471px',
			'1616.1833030030243px 922.2306700947471px',
			'1619.0183341860359px 922.2306700947471px',
			'1619.0183341860359px 922.2306700947471px',
			'1620.2451897857018px 922.2306700947471px',
			'1620.2451897857018px 922.2306700947471px',
			'1621.3891497367415px 922.2306700947471px',
			'1621.3891497367415px 922.2306700947471px',
			'1622.4999514283309px 922.2306700947471px',
			'1622.4999514283309px 922.2306700947471px',
			'1623.6439113793706px 922.2306700947471px',
			'1623.6439113793706px 922.2306700947471px',
			'1624.8707669790365px 922.2306700947471px',
			'1626.0976225787022px 922.2306700947471px',
			'1626.0976225787022px 922.2306700947471px',
			'1627.324478178368px 922.2306700947471px',
			'1629.9771389344023px 922.2306700947471px',
			'1629.9771389344023px 922.2306700947471px',
			'1631.1376780151672px 922.2306700947471px',
			'1631.1376780151672px 922.2306700947471px',
			'1632.2982170959322px 922.2306700947471px',
			'1633.458756176697px 922.2306700947471px',
			'1633.458756176697px 922.2306700947471px',
			'1634.685611776363px 922.2306700947471px',
			'1636.0119421543802px 922.2306700947471px',
			'1637.238797754046px 922.2306700947471px',
			'1638.5651281320631px 922.2306700947471px',
			'1638.5651281320631px 922.2306700947471px',
			'1639.7919837317288px 922.2306700947471px',
			'1639.7919837317288px 922.2306700947471px',
			'1640.886206293593px 922.2306700947471px',
			'1640.886206293593px 922.2306700947471px',
			'1641.9141123365562px 922.2306700947471px',
			'1644.5667730925904px 922.2306700947471px',
			'1645.8931034706077px 922.2306700947471px',
			'1647.2194338486247px 922.2306700947471px',
			'1648.8276094319704px 922.2306700947471px',
			'1650.1539398099876px 922.2306700947471px',
			'1651.4802701880046px 922.2306700947471px',
			'1652.7071257876705px 922.2306700947471px',
			'1652.7071257876705px 922.2306700947471px',
			'1653.8676648684354px 922.2306700947471px',
			'1653.8676648684354px 922.2306700947471px',
			'1655.0282039492004px 922.2306700947471px',
			'1655.0282039492004px 920.6059153816761px',
			'1656.2550595488663px 920.6059153816761px',
			'1656.2550595488663px 920.6059153816761px',
			'1657.4155986296312px 920.6059153816761px',
			'1657.4155986296312px 920.6059153816761px',
			'1658.642454229297px 920.6059153816761px',
			'1658.642454229297px 919.4287971711859px',
			'1658.642454229297px 919.4287971711859px',
			'1659.802993310062px 919.4287971711859px',
			'1659.802993310062px 919.4287971711859px',
			'1660.880636742201px 919.4287971711859px',
			'1660.880636742201px 919.4287971711859px',
			'1662.206967120218px 918.185362441795px',
			'1662.206967120218px 918.185362441795px',
			'1663.433822719884px 916.560607728724px',
			'1663.433822719884px 916.560607728724px',
			'1664.6606783195498px 916.560607728724px',
			'1665.8875339192155px 915.3171729993329px',
			'1665.8875339192155px 915.3171729993329px',
			'1667.0480729999806px 915.3171729993329px',
			'1667.0480729999806px 915.3171729993329px',
			'1669.4354676804112px 914.1400547888427px',
			'1669.4354676804112px 914.1400547888427px',
			'1670.662323280077px 914.1400547888427px',
			'1671.889178879743px 912.8966200594517px',
			'1673.21550925776px 912.8966200594517px',
			'1673.21550925776px 912.8966200594517px',
			'1674.442364857426px 912.8966200594517px',
			'1674.442364857426px 912.8966200594517px',
			'1675.53658741929px 912.8966200594517px',
			'1675.53658741929px 911.2718653463808px',
			'1675.53658741929px 911.2718653463808px',
			'1676.6473891108794px 911.2718653463808px',
			'1676.6473891108794px 911.2718653463808px',
			'1677.7416116727434px 911.2718653463808px',
			'1677.7416116727434px 909.9289558386384px',
			'1679.0679420507606px 909.9289558386384px',
			'1679.0679420507606px 909.9289558386384px',
			'1680.2284811315255px 909.9289558386384px',
			'1681.4553367311914px 909.9289558386384px',
			'1681.4553367311914px 909.9289558386384px',
			'1682.682192330857px 908.3042011255675px',
			'1684.0085227088744px 908.3042011255675px',
			'1684.0085227088744px 908.3042011255675px',
			'1685.23537830854px 908.3042011255675px',
			'1686.5617086865573px 906.6794464124965px',
			'1688.169884269903px 906.6794464124965px',
			'1690.8225450259372px 906.6794464124965px',
			'1692.1488754039542px 906.6794464124965px',
			'1693.4752057819715px 906.6794464124965px',
			'1694.8015361599885px 906.6794464124965px',
			'1694.8015361599885px 905.0546916994256px',
			'1696.1278665380057px 905.0546916994256px',
			'1697.4541969160227px 905.0546916994256px',
			'1697.4541969160227px 905.0546916994256px',
			'1698.6147359967877px 905.0546916994256px',
			'1698.6147359967877px 905.0546916994256px',
			'1699.7752750775528px 905.0546916994256px',
			'1701.0021306772185px 905.0546916994256px',
			'1701.0021306772185px 905.0546916994256px',
			'1702.1460906282582px 903.8941526186605px',
			'1702.1460906282582px 903.8941526186605px',
			'1703.3066297090234px 903.8941526186605px',
			'1703.3066297090234px 903.8941526186605px',
			'1704.4008522708873px 903.8941526186605px',
			'1704.4008522708873px 903.8941526186605px',
			'1705.461916573301px 903.8941526186605px',
			'1705.461916573301px 903.8941526186605px',
			'1706.5395600054399px 903.8941526186605px',
			'1706.5395600054399px 903.8941526186605px',
			'1706.5395600054399px 902.7999300567965px',
			'1707.865890383457px 902.7999300567965px',
			'1707.865890383457px 902.7999300567965px',
			'1707.3519373619754px 902.7999300567965px',
			'1707.3519373619754px 902.7999300567965px',
			'1706.2245565406608px 902.7999300567965px',
			'1705.0474383301707px 902.7999300567965px',
			'1703.8703201196806px 902.7999300567965px',
			'1702.5274106119382px 902.7999300567965px',
			'1702.5274106119382px 902.7999300567965px',
			'1699.6260629100257px 902.7999300567965px',
			'1695.6636509056996px 902.7999300567965px',
			'1692.3312458309317px 902.7999300567965px',
			'1690.590437209784px 902.7999300567965px',
			'1683.129828833438px 902.7999300567965px',
			'1676.5810725919785px 902.7999300567965px',
			'1676.5810725919785px 902.7999300567965px',
			'1650.2202563288884px 909.431581946882px',
			'1635.149827408669px 910.9237036221513px',
			'1616.1335656138488px 914.9690112751034px',
			'1616.1335656138488px 914.9690112751034px',
			'1598.1286307322664px 917.9200963661915px',
			'1586.5066607948916px 919.8764336737668px',
			'1581.8810836015568px 920.0256458412937px',
			'1573.6412561281256px 920.0919623601945px',
			'1565.600378211397px 922.1975118352967px',
			'1562.3177105258044px 922.2804074839228px',
			'1545.4069982060862px 923.5901587322146px',
			'1536.7692716192498px 923.8720039375432px',
			'1529.723141486034px 923.8720039375432px',
			'1523.058331336498px 923.8720039375432px',
			'1518.482491532339px 923.8720039375432px',
			'1512.3482135340098px 925.4636003911638px',
			'1506.230514665406px 925.4636003911638px',
			'1506.230514665406px 925.4636003911638px',
			'1491.8729883233707px 927.569149866266px',
			'1483.997901703894px 928.4312646119771px',
			'1474.9291177442021px 929.276800227963px',
			'1468.496415410819px 929.890228027796px',
			'1460.8368574777703px 930.752342773507px',
			'1452.829137820492px 931.5647201300425px',
			'1449.4304162268231px 932.3439392271275px',
			'1438.3721367001056px 933.5542156970682px',
			'1434.0284047120995px 934.6650173886575px',
			'1425.5233111630648px 934.6650173886575px',
			'1419.1569253485827px 934.6650173886575px',
			'1415.923995052166px 934.6650173886575px',
			'1409.3918179404316px 936.8368833826605px',
			'1403.1912234232016px 936.870041642111px',
			'1400.6048791860683px 936.870041642111px',
			'1394.8850794308696px 938.7269041713349px',
			'1392.8790047341186px 938.9258537280375px',
			'1381.5223008723472px 939.0419076361139px',
			'1378.3722662245564px 939.0419076361139px',
			'1373.6637933825957px 939.0419076361139px',
			'1368.3916301299778px 939.0419076361139px',
			'1364.5950094229038px 939.0419076361139px',
			'1359.7207452836908px 939.0419076361139px',
			'1354.7635854958519px 939.0419076361139px',
			'1351.4809178102596px 939.0419076361139px',
			'1347.7671927518118px 939.0419076361139px',
			'1341.6992312723835px 939.0419076361139px',
			'1336.5265427981167px 939.0419076361139px',
			'1333.144400334173px 939.0419076361139px',
			'1319.350564402795px 939.8377058629243px',
			'1313.6307646475964px 940.6335040897345px',
			'1301.8430034129692px 940.6335040897345px',
			'1295.6589880254644px 942.1090466352786px',
			'1289.1433900434554px 942.225100543355px',
			'1280.2569765107407px 942.225100543355px',
			'1277.886160960035px 942.225100543355px',
			'1277.886160960035px 942.225100543355px',
			'1266.8444605630427px 943.8001178672504px',
			'1260.428337359385px 943.8166969969756px',
			'1253.9127393773758px 946.021721250429px',
			'1248.1266231032762px 946.021721250429px',
			'1242.9041972398338px 946.021721250429px',
			'1233.304881128935px 946.021721250429px',
			'1228.1487717843936px 946.021721250429px',
			'1224.6008380231979px 946.021721250429px',
			'1219.1794626030528px 946.021721250429px',
			'1219.1794626030528px 946.021721250429px',
			'1214.5207271502677px 946.021721250429px',
			'1207.1098561630972px 946.021721250429px',
			'1205.5016805797513px 946.021721250429px',
			'1203.926663255856px 946.021721250429px',
			'1201.1247903322949px 946.021721250429px',
			'1198.1571261114816px 946.021721250429px',
			'1194.7418253880876px 946.021721250429px',
			'1191.4425785727701px 946.021721250429px',
			'1188.0438569791013px 946.021721250429px',
			'1186.6843683416337px 946.021721250429px',
			'1184.0648658450498px 946.021721250429px',
			'1180.6993025108313px 946.021721250429px',
			'1177.3171600468877px 946.021721250429px',
			'1175.6260888149159px 946.021721250429px',
			'1172.3268419995984px 946.021721250429px',
			'1170.9507742324056px 946.021721250429px',
			'1168.2483760871958px 946.021721250429px',
			'1166.6070422443997px 946.021721250429px',
			'1163.2414789101813px 946.021721250429px',
			'1163.2414789101813px 946.021721250429px',
			'1155.2834966420785px 947.6133177040496px',
			'1153.9405871343363px 947.6133177040496px',
			'1149.0994812545737px 947.6133177040496px',
			'1147.3586726334263px 947.6133177040496px',
			'1145.7173387906303px 947.6133177040496px',
			'1142.517566753664px 948.4091159308598px',
			'1141.141498986471px 949.20491415767px',
			'1138.3893634520857px 949.20491415767px',
			'1135.1895914151194px 949.20491415767px',
			'1135.1895914151194px 949.20491415767px',
			'1131.9566611187026px 949.20491415767px',
			'1128.955838638439px 949.20491415767px',
			'1127.5963500009714px 950.5478236654124px',
			'1126.104228325702px 950.7136149626646px',
			'1124.612106650433px 950.7965106112906px',
			'1123.1863014940645px 950.7965106112906px',
			'1121.9594458943986px 950.7965106112906px',
			'1121.9594458943986px 950.7965106112906px',
			'1120.7491694244582px 950.7965106112906px',
			'1120.7491694244582px 950.7965106112906px',
			'1119.422839046441px 950.7965106112906px',
			'1118.1462460575995px 950.7965106112906px',
			'1118.1462460575995px 950.7965106112906px',
			'1116.8199156795824px 951.8741540434295px',
			'1116.8199156795824px 951.8741540434295px',
			'1115.4438479123896px 951.90731230288px',
			'1115.4438479123896px 951.90731230288px',
			'1114.2004131829985px 951.9570496920555px',
			'1113.0398741022336px 951.9570496920555px',
			'1113.0398741022336px 951.9570496920555px',
			'1111.7964393728425px 951.9570496920555px',
			'1110.6027420326272px 951.9570496920555px',
			'1110.6027420326272px 951.9570496920555px',
			'1110.0058933625194px 952.5538983621633px',
			'1109.342728173511px 953.2004844214466px',
			'1108.0163977954937px 953.2502218106223px',
			'1106.789542195828px 953.2502218106223px',
			'1106.789542195828px 953.2502218106223px',
			'1104.319251866771px 953.2502218106223px',
			'1102.9763423590289px 953.2502218106223px',
			'1102.9763423590289px 953.2502218106223px',
			'1101.749486759363px 953.2502218106223px',
			'1101.1526380892553px 953.8139122212796px',
			'1100.3734189921702px 954.3776026319368px',
			'1098.9310347060766px 954.4107608913872px',
			'1098.9310347060766px 954.4107608913872px',
			'1097.6875999766855px 954.4439191508377px',
			'1096.5270608959206px 954.4439191508377px',
			'1096.5270608959206px 954.4439191508377px',
			'1095.2670470368043px 954.4439191508377px',
			'1095.2670470368043px 954.4439191508377px',
			'1094.1065079560394px 954.4439191508377px',
			'1094.1065079560394px 954.4439191508377px',
			'1115.4438479123896px 954.4439191508377px',
			'1163.8714858397393px 949.7520254386021px',
			'1248.4084683086048px 938.5113754849071px',
			'1366.3523971737764px 925.3807047425378px',
			'1497.1451515759886px 925.3807047425378px',
			'1497.1451515759886px 925.3807047425378px',
			'1771.579485917454px 925.3807047425378px',
			'1889.5234147826254px 925.3807047425378px',
			'1984.356036810849px 937.2182033663404px',
			'2106.013690734468px 948.425695060585px',
			'2163.460375232334px 952.4875818432624px',
			'2242.7583527080324px 956.5494686259398px',
			'2307.9806490470237px 966.5135255907934px',
			'2364.1838988154987px 971.1888401733037px',
			'2412.6115367428483px 979.9260415384914px',
			'2440.1992086056043px 983.3745005213359px',
			'2462.498138086017px 986.8229595041804px',
			'2475.4630175311345px 989.044562887359px',
			'2492.473204629204px 991.8795940703706px',
			'2514.772134109616px 991.8795940703706px',
			'2550.864899521407px 998.1630842362266px',
			'2584.9847484958973px 998.1630842362266px',
			'2619.1045974703875px 1002.2249710189041px',
			'2653.2244464448777px 1002.2249710189041px',
			'2675.52337592529px 1002.2249710189041px',
			'2692.5335630233594px 1002.2249710189041px',
			'2705.4984424684767px 1002.2249710189041px',
			'2711.566403947905px 1002.2249710189041px',
			'2720.48597574007px 1002.2249710189041px',
			'2726.5539372194985px 999.9867885060002px',
			'2729.77028838619px 998.3620337929292px',
			'2734.594815136227px 998.3620337929292px',
			'2737.8111663029185px 996.7372790798582px',
			'2742.635693052956px 996.7372790798582px',
			'2748.703654532384px 996.7372790798582px',
			'2754.7716160118125px 996.7372790798582px',
			'2760.839577491241px 996.7372790798582px',
			'2769.759149283406px 996.7372790798582px',
			'2775.8271107628343px 996.7372790798582px',
			'2779.0434619295256px 996.7372790798582px',
			'2785.111423408954px 996.7372790798582px',
			'2788.3277745756454px 996.7372790798582px',
			'2791.5441257423367px 996.7372790798582px',
			'2794.7604769090285px 996.7372790798582px',
			'2797.6949828703914px 996.7372790798582px',
			'2799.303158453737px 996.7372790798582px',
			'2800.9113340370827px 996.7372790798582px',
			'2802.2376644151px 996.7372790798582px',
			'2803.5639947931168px 996.7372790798582px',
		],
		{
			extrapolateLeft: 'clamp',
			extrapolateRight: 'clamp',
		},
	);

const TimelineAudioRollingEditContent = ({
	cursorSpin,
}: {
	readonly cursorSpin: boolean;
}) => {
	const {fps} = useVideoConfig();
	const motionFrame = useCurrentFrame();
	// Include the lead-in, mouse-down at source frame 167, and the start of the drag.
	const frame = cursorSpin
		? 100 + (motionFrame * 60 * (70 / 51)) / fps
		: (motionFrame * 60) / fps;
	// Stop following the pointer before the press so its recorded drag stays visible.
	const [focusX, focusY] = getAudioRollingCursorTranslate(
		cursorSpin ? Math.min(frame, 166) : frame,
	)
		.split(' ')
		.map(Number.parseFloat);

	const capture = (
		<>
			<Video
				src={
					'https://remotion.media/studio-close-ups/timeline-audio-rolling-edit-6cd5c48318ad.mp4'
				}
				durationInFrames={(797 / 60) * fps}
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<Solid
				name="Match empty bottom-left corner to timeline background"
				color="#15161b"
				width={1328}
				height={96}
				// Keep the recorded track labels and controls above this blank corner.
				style={{position: 'absolute', left: 0, top: 1114}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[-223, -102, -100, -47, 447],
					['auto', 'col-resize', 'auto', 'custom', 'auto'],
					{
						easing: [Easing.step1, Easing.step1, Easing.step1, Easing.step1],
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				customCursor={interpolate(
					cursorSpin ? 119 : frame,
					[-47, 16, 79, 119],
					[
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20transform%3D%22translate(32%200)%20scale(-1%201)%22%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M7%204.5H11C12.1%204.5%2013%205.4%2013%206.5V25.5C13%2026.6%2012.1%2027.5%2011%2027.5H7M25%204.5H21C19.9%204.5%2019%205.4%2019%206.5V25.5C19%2026.6%2019.9%2027.5%2021%2027.5H25%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, ew-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cg%20filter%3D%22url(%23shadow)%22%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M23%204.5H18C16.9%204.5%2016%205.4%2016%206.5V25.5C16%2026.6%2016.9%2027.5%2018%2027.5H23%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fg%3E%0A%3Cdefs%3E%0A%3Cfilter%20id%3D%22shadow%22%20x%3D%220%22%20y%3D%220%22%20width%3D%2232%22%20height%3D%2232%22%20filterUnits%3D%22userSpaceOnUse%22%3E%0A%3CfeDropShadow%20dx%3D%220%22%20dy%3D%221.5%22%20stdDeviation%3D%221%22%20flood-color%3D%22black%22%20flood-opacity%3D%220.35%22%2F%3E%0A%3C%2Ffilter%3E%0A%3C%2Fdefs%3E%0A%3C%2Fsvg%3E") 12 12, e-resize',
						'url("data:image/svg+xml,%3Csvg%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2032%2032%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22white%22%20stroke-width%3D%225%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3Cpath%20d%3D%22M5%206H3V26H5M27%206H29V26H27M8%2016H24M8%2016L12%2012M8%2016L12%2020M24%2016L20%2012M24%2016L20%2020%22%20stroke%3D%22black%22%20stroke-width%3D%222.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%0A%3C%2Fsvg%3E") 2 12, ew-resize',
					],
					{
						easing: [Easing.step1, Easing.step1, Easing.step1],
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[-245, 167, 365, 498, 506],
						[
							4.244257209654752, 3.8198314886892772, 4.244257209654752,
							3.8198314886892772, 4.244257209654752,
						],
						{
							easing: [Easing.step1, Easing.step1, Easing.step1, Easing.step1],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: getAudioRollingCursorTranslate(frame),
				}}
			/>
		</>
	);

	return (
		<AbsoluteFill showInTimeline={false} style={{backgroundColor: '#15161b'}}>
			<AbsoluteFill
				name="Canvas Capture"
				durationInFrames={((cursorSpin ? 452 : 552) / 60) * fps}
				style={{
					width: 2560,
					height: 1210,
					left: cursorSpin ? '50%' : 0,
					top: cursorSpin ? '50%' : 0,
					transformOrigin: cursorSpin ? `${focusX}px ${focusY}px` : '50% 50%',
					rotate: cursorSpin
						? interpolate(frame, [100, 166], ['180deg', '0deg'], {
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
								easing: Easing.bezier(0.45, 0, 0.55, 1),
							})
						: '-0.210862 0.975956 -0.055193 30.026402deg',
					scale: cursorSpin
						? interpolate(frame, [100, 166], [3.2, 1.8], {
								extrapolateLeft: 'clamp',
								extrapolateRight: 'clamp',
								easing: Easing.bezier(0.45, 0, 0.55, 1),
								output: 'perceptual-scale',
							})
						: 1.476,
					translate: cursorSpin ? `${-focusX}px ${-focusY}px` : '-800px -519px',
				}}
				trimBefore={((cursorSpin ? 345 : 245) / 60) * fps}
				playbackRate={cursorSpin ? 70 / 51 : 1}
			>
				{!cursorSpin && HtmlInCanvas.isSupported() ? (
					<HtmlInCanvas
						name="Full capture before camera transform"
						// Rasterize the full source before rotating it, avoiding an inner crop.
						width={2560}
						height={1210}
						style={{position: 'absolute', backgroundColor: '#15161b'}}
						effects={[
							linearProgressiveBlur({
								end: [0, 0.6],
								start: [0.5, 0.5],
								endBlur: 11,
							}),
						]}
					>
						{capture}
					</HtmlInCanvas>
				) : (
					capture
				)}
			</AbsoluteFill>
		</AbsoluteFill>
	);
};

const AudioRollingCursorMotionBlur = () => {
	const motionFrame = useCurrentFrame();
	const {fps, width, height, durationInFrames} = useVideoConfig();
	const sourceFrame = 100 + (motionFrame * 60 * (70 / 51)) / fps;
	const rotating = sourceFrame < 166;

	// Once settled, keep the drag in the DOM without an intermediate canvas crop.
	if (!rotating) {
		const settledFrame = (66 * fps) / (60 * (70 / 51));
		const pauseEndFrame = Math.ceil(settledFrame) + Math.round(0.2 * fps);
		const lastFrame = durationInFrames - 1;
		const dragEndFrame = settledFrame + ((51 / 30) * fps - 1 - settledFrame) * 1.5;

		return (
			<AbsoluteFill
				showInTimeline={false}
				style={{
					scale: interpolate(
						motionFrame,
						[settledFrame, lastFrame],
						[1, width < height ? 0.76 : 0.94],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			>
				<Freeze
					frame={interpolate(
						motionFrame,
						[pauseEndFrame - 1, lastFrame],
						[settledFrame, dragEndFrame],
						{extrapolateLeft: 'clamp'},
					)}
				>
					<TimelineAudioRollingEditContent cursorSpin />
				</Freeze>
			</AbsoluteFill>
		);
	}

	if (HtmlInCanvas.isSupported()) {
		return (
			<div style={{position: 'absolute', left: -320, top: -320}}>
				<HtmlInCanvasMotionBlur
					name="Cursor-centered half turn - padded capture"
					width={2560}
					height={Math.ceil((height * 1920) / width) + 640}
					durationInFrames={(552 / 60) * fps}
					shutterAngle={360}
					samples={12}
				>
					<div
						style={{
							position: 'absolute',
							left: 320,
							top: 320,
							width: 1920,
							height: (height * 1920) / width,
							overflow: 'visible',
						}}
					>
						<TimelineAudioRollingEditContent cursorSpin />
					</div>
				</HtmlInCanvasMotionBlur>
			</div>
		);
	}

	const samples = 8;

	// Average shutter samples in browsers without HTML-in-canvas.
	// Later opaque samples use 1/n opacity to keep every sample weighted equally.
	return Array.from({length: samples}, (_, sample) => (
		<AbsoluteFill
			key={sample}
			showInTimeline={false}
			style={{opacity: 1 / (sample + 1)}}
		>
			<Freeze frame={Math.max(0, motionFrame + (sample + 0.5) / samples - 0.5)}>
				{sample === Math.floor(samples / 2) ? (
					<TimelineAudioRollingEditContent cursorSpin />
				) : (
					<Internals.DisableSequenceRegistrationProvider>
						<TimelineAudioRollingEditContent cursorSpin />
					</Internals.DisableSequenceRegistrationProvider>
				)}
			</Freeze>
		</AbsoluteFill>
	));
};

const TimelineAudioRollingEditCompositionContent = ({
	cursorSpin,
}: {
	readonly cursorSpin: boolean;
}) => {
	const {width, height} = useVideoConfig();

	return (
		<AbsoluteFill
			showInTimeline={false}
			style={{backgroundColor: '#15161b', overflow: 'hidden'}}
		>
			<div
				style={{
					position: 'absolute',
					width: 1920,
					height: (height * 1920) / width,
					left: '50%',
					top: '50%',
					translate: '-50% -50%',
					scale: width / 1920,
					overflow: 'visible',
				}}
			>
				{cursorSpin ? (
					<AudioRollingCursorMotionBlur />
				) : (
					<TimelineAudioRollingEditContent cursorSpin={false} />
				)}
			</div>
		</AbsoluteFill>
	);
};

export const TimelineAudioRollingEditComposition = Interactive.create({
	Component: TimelineAudioRollingEditCompositionContent,
	layout: 'absolute-fill',
	schema: {
		...Interactive.backgroundSchema,
		cursorSpin: {
			type: 'boolean',
			default: false,
			description: 'Close-up half turn around the cursor',
		},
	},
});
